import * as _ from 'lodash';
import {GEO_TYPES} from '../../constants';
import initialTags from './initial-tag-titles';

export default angular.module('cian.newbuild.filter.tagTitleService', [])
  .factory('TagTitleService', [
    '$log',
    '$window',
    '$locale',
    'FilterTermsService',
    function($log, $window, $locale, FilterTermsService) {
    /** @namespace TagTitleService */
    const service = {};

    /**
     * Хранилище названий тэгов для параметров,
     * которые мы получаем из внешних источников (API, window)
     * @type {Object<string, Object<string,string>>}
     * @example
     * {
     *  specialty_types: {
     *    7008: 'Автомойка'
     *  }
     * }
     */
    const storedTitles = initialTags || {};

    /**
     * @param filterParamName
     * @param value
     * @param title
     */
    service.saveTitle = (filterParamName, value, title) => {
      _.set(storedTitles, [filterParamName, String(value)], title)
    };

    /**
     * @param {object} data
     * @param {string} data.key — параметр фильтра (например, price или specialty_types)
     * @param {*} data.value
     * @return {string}
     */
    service.getTitle = function (data, { isNewBuilding, dealType } = {}) {
      $log.debug('getTitle', data);

      if (typeof data.value === 'boolean') {
        return _getTitleByBool(data.key, data.value);
      }

      let text;

      switch (data.key) {
        case 'publish_period':
          text = _getTermText('publish_period', data.value, { prefix: 'Опубликовано: ' });
          break;
        case 'room':
          text = _getTermText('roomTypes', data.value);
          break;
        case 'rooms_count':
          text = `Комнат в квартире: ${data.value}`;
          break;
        case 'rooms_for_sale':
          text = [
            'Комнат ',
            dealType === 'rent' ? 'в аренду' : 'на продажу',
            ': ',
            _getRangePart(data.value)
          ].join('');
          break;
        case 'price':
          text = 'Цена' + _getRangePart(data.value);
          break;
        case 'total_area':
          text = `Общая площадь ${_getRangePart(data.value)} м²`;
          break;
        case 'room_area':
          text = 'Площадь комнаты' + _getRangePart(data.value);
          break;
        case 'living_area':
          text = 'Жилая площадь' + _getRangePart(data.value);
          break;
        case 'kitchen':
          text = 'Площадь кухни' + _getRangePart(data.value);
          break;
        case 'site':
          text = 'Площадь участка' + _getRangePart(data.value) + ' сот.';
          break;
        case 'commerce_rooms':
          text = 'Комнат' + _getRangePart(data.value);
          break;
        case 'floor':
          text = 'Этаж' + _getRangePart(data.value);
          break;
        case 'floorn':
          text = 'Этажей в здании' + _getRangePart(data.value);
          break;
        case 'bedroom_total':
          text = 'Спален минимум ' + data.value.gte;
          break;
        case 'prepay':
          text = _getTermText(data.key, data.value, {
            prefix: 'Предоплата '
          });
          break;
        case 'from_mcad_km':
          text = 'До МКАД ' + _getRangePart(data.value) + ' км';
          break;
        case 'description_include':
          text = 'Содержит «' + data.value + '»';
          break;
        case 'description_exclude':
          text = 'Не содержит «' + data.value + '»';
          break;
        case 'bs_center':
          text = getStoredTitle(data.key, data.value) || `БЦ №${data.value}`;
          break;
        case 'geo':
          switch (data.value.type) {
            case GEO_TYPES.HIGHWAY:
              const highwayName = data.value.text;
              text = highwayName.includes('шоссе') ?
                highwayName : `${highwayName} шоссе`;
              break;
            case GEO_TYPES.BUILDER:
              text = $window._landingHeader.builder ?
                `Застройщик «${$window._landingHeader.builder.name}»` :
                `Застройщик №${data.value.id}`;
              break;
            case GEO_TYPES.NEWOBJECT:
              text = data.value.text || `ЖК №${data.value.id}`;
              break;
            case GEO_TYPES.UNDERGROUND:
              // Если не знаем цвет ветки, то поясняем, что это метро
              text = (data.value.color ? '' : 'Метро ') + data.value.text;
              break;
            default:
              text = data.value.text;
          }
          break;
        case 'lifts':
          text = 'Лифтов минимум ' + data.value;
          break;
        case 'lift_passanger':
          text = 'Лифтов минимум ' + data.value.gte;
          break;
        case 'lift_service':
          if (data.value.gte) {
            text = 'Есть грузовой лифт';
          }
          break;
        case 'wc':
          text = 'Санузлов минимум ' + data.value.gte;
          break;
        case 'wc_type':
          text = _getTermText(data.key, data.value, {
            postfix: ' санузел'
          });
          break;
        case 'wc_site':
          text = _getTermText(data.key, data.value, {
            prefix: 'Санузел '
          });
          break;
        case 'house_class':
        case 'building_class_type':
        case 'building_class_type__warehouse':
          text = _getTermText(data.key, data.value, {
            prefix: 'Класс ',
            keepCase: true
          });
          break;
        case 'phone_lines_count':
          text = 'Телефонных линий минимум ' + data.value.gte;
          break;
        case 'year':
          text = 'Год сдачи ' + data.value;
          break;
        case 'yeargte':
          text = `Год ${isNewBuilding ? 'сдачи' : 'постройки'}: позднее ${data.value}`
          break;
        case 'yearlte':
          text = `Год ${isNewBuilding ? 'сдачи' : 'постройки'}: раньше ${data.value}`
          break;
        case 'house_year':
          text = `Год ${isNewBuilding ? 'сдачи' : 'постройки'}` + _getRangePart(data.value);
          break;
        case 'currency':
          text = _getTermText(data.key, data.value, {
            prefix: 'Цена '
          });
          break;
        case 'contact':
          text = 'Телефон +7' + data.value;
          break;
        case 'composition':
          text = _getTermText(data.key, data.value, {
            prefix: 'Состав съёмщиков: '
          });
          break;
        case 'for_day':
          text = _getTermText(data.key, data.value, {
            prefix: 'Срок аренды: '
          });
          break;
        case 'windows_type':
          text = _getTermText(data.key, data.value, {
            prefix: 'Окна '
          });
          break;
        case 'balconies':
          text = 'Есть балкон';
          break;
        case 'id_user':
          text = 'Объявления пользователя ' + data.value;
          break;
        case 'sub_agent_ids':
          text = `Объявления сотрудника ${data.value}`;
          break;
        case 'multi_id':
          text = `Мультиобъявление №${data.value}`;
          break;
        case '_highway_directions':
          text = data.value.name + ' направление';
          break;
        case 'ceiling_height':
          text = 'Высота потолков ' + _getRangePart(data.value) + ' м';
          break;
        case 'id':
          text = `Объявление №${data.value}`;
          break;
        default:
          text = _getTermText(data.key, data.value);
          break;
      }

      return text;
    };

    function _getRangePart(value) {
      $log.debug('_getRangePart', value)
      if (value.gte === value.lte) {
        return ' ' + value.gte;
      } else {
        return (value.gte?' от ' + value.gte:'') + (value.lte?' до ' + value.lte:'');
      }
    }

    function _getTermText(termName, value, options) {
      $log.debug('_getTermText', termName, value, options);

      options = options || {};

      var textsTerm = FilterTermsService[termName + 'Texts'];

      if (textsTerm) {
        var textItem = textsTerm[value];

        if (!angular.isUndefined(textItem)) {
          var prefix = options.prefix || '';
          if (prefix && !options.keepCase) {
            textItem = textItem.toLowerCase();
          }
          var postfix = options.postfix || '';

          return prefix + textItem + postfix;
        }
      }

      const storedTitle = getStoredTitle(termName, value);
      if (storedTitle) return storedTitle;

      $log.error('No text for tag', termName, 'with value', value);
      return `${termName}: ${value}`;
    }

    function getStoredTitle(termName, value) {
      return _.get(storedTitles, [termName, String(value)]);
    }

    var boolTextDict = {
      'has_kitchen_furniture': {
        true: 'С кухонной мебелью',
        false: 'Без кухонной мебели'
      },
      'has_fridge': {
        true: 'С холодильником',
        false: 'Без холодильника'
      },
      'penthouse': {
        true: 'Пентхаус',
        false: 'Не пентхаус'
      },
      'cl': {
        true: '«Агентам не звонить»',
        false: 'Без «Агентам не звонить»'
      },
      'tv': {
        true: 'С телевизором',
        false: 'Без телевизора'
      },
      'has_washer': {
        true: 'Со стиральной машиной',
        false: 'Без стиральной машины'
      },
      'phone': {
        true: 'С телефоном',
        false: 'Без телефона'
      },
      'minbalkon': {
        true: 'С балконом',
        false: 'Без балкона'
      },
      'loggia': {
        true: 'С лоджией',
        false: 'Без лоджии'
      },
      'wp': {
        true: 'С фото',
        false: 'Без фото'
      },
      'kids': {
        true: 'Можно с детьми',
        false: 'Нельзя с детьми'
      },
      'pets': {
        true: 'Можно с животными',
        false: 'Нельзя с животными'
      },
      'shower': {
        true: 'Душевая кабина',
        false: 'Без душевой кабины'
      },
      'internet': {
        true: 'С интернетом',
        false: 'Без интернета'
      },
      'conditioner': {
        true: 'С кондиционером'
      },
      'dish_washer': {
        true: 'С посудомоечной машиной'
      },
      'zalog': {
        true: 'С залогом',
        false: 'Без залога'
      },
      'bath': {
        true: 'С ванной',
        false: 'Без ванны'
      },
      'bathhouse': {
        true: 'С баней',
        false: 'Без бани'
      },
      'garage': {
        true: 'С гаражом',
        false: 'Без гаража'
      },
      'pool': {
        true: 'С бассейном',
        false: 'Без бассейна'
      },
      'electricity': {
        true: 'С электричеством',
        false: 'Без электричества'
      },
      'parking': {
        true: 'С парковкой',
        false: 'Без парковки'
      },
      'lift': {
        true: 'С лифтом',
        false: 'Без лифта'
      },
      'has_drainage': {
        true: 'С канализацией',
        false: 'Без канализации'
      },
      'has_water': {
        true: 'Есть водоснабжение',
        false: 'Без водоснабжения'
      },
      'gas': {
        true: 'С газом',
        false: 'Без газа'
      },
      'not_last_floor': {
        true: 'Не последний этаж',
        false: 'Только последний этаж'
      },
      'is_first_floor': {
        true: 'Только первый этаж',
        false: 'Не первый этаж'
      },
      'is_basement': {
        true: 'Подвал',
        false: 'Не подвал'
      },
      'is_semibasement': {
        true: 'Полуподвал',
        false: 'Не полуподвал'
      },
      'enter': {
        true: 'Вход по пропускам',
        false: 'Свободный вход'
      },
      'ipoteka': {
        true: 'Возможна ипотека',
        false: 'Без ипотеки'
      },
      'room': {
        true: 'Комната',
        false: 'Не комната'
      },
      'bed_space': {
        true: 'Койко-место',
        false: 'Не койко-место'
      },
      'flat': {
        true: 'Квартира',
        false: 'Не квартира'
      },
      'add_phones': {
        true: 'С возможностью увеличения числа тел. линий'
      },
      'price_sm': {
        true: 'Цена за м²'
      },
      'promo': {
        true: 'По акции'
      },
      'is_in_hidden_base': {
        true: 'Только видимые агентам',
        false: 'Кроме видимых только агентам',
      },
    };

    function _getTitleByBool(key, value) {
      $log.debug('_getTitleByBool', key, value)
      var keyDict = boolTextDict[key];
      if (!angular.isUndefined(keyDict)) {
        return keyDict[value];
      } else {
        // Если нет здесь, берём из сервиса со словарями
        return _getTermText(key, value);
        // P.S. Желательно перенести весь boolTextDict в словари
      }
    }

    return service;
  }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/tag-title/tag-title.service.js